import { lazy } from "react";

// project import
import Loadable from "components/Loadable";
import MinimalLayout from "layout/MinimalLayout";
import { useInstance } from "easy-redux-http-call";
import { AI_getUserData } from "APIs/user";
import { Navigate } from "react-router-dom";

// render - login
const AuthLogin = Loadable(lazy(() => import("pages/authentication/Login")));
const AuthRegister = Loadable(
  lazy(() => import("pages/authentication/Register"))
);
const ResetPassword = Loadable(
  lazy(() => import("pages/authentication/ResetPassword/ResetPassword"))
);
const ForgotPassword = Loadable(
  lazy(() => import("pages/authentication/ResetPassword/ForgotPassword"))
);
const Form = Loadable(lazy(() => import("pages/Form/Form")));
const PasswordResetMessage = Loadable(
  lazy(() => import("pages/authentication/ResetPassword/LinkExpired"))
);
const SamplePage = Loadable(
  lazy(() => import("pages/extra-pages/SamplePage"))
);
// ==============================|| AUTH ROUTING ||============================== //

const token = localStorage.getItem("token");
const ProtectedRoute = ({ component }) => {
  const userData = useInstance(AI_getUserData);
  const is_form_submit = userData?.data?.user?.is_submit;
  return token ? (
    is_form_submit ? (
      <Navigate to="/" replace />
    ) : (
      component
    )
  ) : (
    <Navigate to="/login" />
  );
};

const LoginRoutes = {
  path: "/",
  element: <MinimalLayout />,
  children: [
    {
      path: "login",
      element: <AuthLogin />,
    },
    {
      path: "reset-password/:token",
      element: <ResetPassword />,
    },
    {
      path: "forgot-password",
      element: <ForgotPassword />,
    },
    {
      path: "reset-password",
      element: <PasswordResetMessage />,
    },
    {
      path: "developer/:token/:username",
      element: <SamplePage />,
    },
    {
      path: "/form",
      element: <ProtectedRoute component={<Form />} />,
    },
  ],
};

export default LoginRoutes;
